export const FinancialSearchCondition = [{
  name: '金融服务分类',
  key: '金融服务分类',
  open: false,
  box: [{
    title: '',
    key: '0',
    list: [{
      title: '',
      key: '0-0',
      items: [{
          index: 0,
          name: '全部',
          key: '金融全部',
          active: false
        },
        {
          index: 1,
          name: '银行服务',
          key: '银行服务',
          active: false
        },
        {
          index: 2,
          name: '风险投资',
          key: '风险投资',
          active: false
        },
        {
          index: 3,
          name: '投资基金',
          key: '投资基金',
          active: false
        },
        {
          index: 4,
          name: '融资担保',
          key: '融资担保',
          active: false
        },
        {
          index: 5,
          name: '债券股票',
          key: '债券股票',
          active: false
        },
        {
          index: 6,
          name: '民间借贷',
          key: '民间借贷',
          active: false
        },
      ]
    }, ]
  }, ]
}, ]
